import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
var colour = variables.colour;
export var placeholder = /*#__PURE__*/css("position:relative;width:100%;height:29%;top:35.5%;background-size:contain;background-repeat:no-repeat;background-position:center;stroke:", colour.neutral300, ";fill:none;stroke-width:2px;stroke-miterlimit:10;stroke-linecap:square;stroke-linejoin:round;text-align:center;.round{stroke-linecap:round;}");
export var houseImage = {
  name: "10klw3m",
  styles: "height:100%;"
};